import { Typography } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './styles/SupportQueueTable.styles'

const SupportQueueRowSkeleton: React.FC = () => {
  const classes = useStyles()

  return (
    <div className={classes.tableRow}>
      {Array(6)
        .fill('')
        .map((_, index) => (
          <div key={`support-queue-skeleton-cell-${index.toString()}`}>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
        ))}
      <div />
    </div>
  )
}

export default SupportQueueRowSkeleton
